import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { StockItemGroupInInventoryWithStatsSummariesDto } from './type/StockItemGroupInInventoryWithStatsSummariesDto';

const ENDPOINT = `${APIConfiguration.sparePart}stockInventory/${COMMON_QUERY_PARAMS.STOCK_ITEM_ID}/StockItemGroupsInInventory`;

export interface GetStockItemGroupInInventoryByStockInventoryQueryArgs {
  stockInventoryId: string;
  toCount?: boolean;
  isCounted?: boolean;
  isChecked?: boolean;
  searchTerm?: string;
  page?: number;
  pageSize?: number;
}

export default async function getStockItemGroupInInventoryByStockInventoryQuery(
  payload: GetStockItemGroupInInventoryByStockInventoryQueryArgs,
): Promise<
  | BackResponse<StockItemGroupInInventoryWithStatsSummariesDto>
  | BackResponseFailure
> {
  try {
    const base = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.STOCK_ITEM_ID,
      payload.stockInventoryId,
    );
    const url = buildUrl(base, {
      toCount: payload.toCount,
      isCounted: payload.isCounted,
      isChecked: payload.isChecked,
      searchTerm: payload.searchTerm,
      page: payload.page ?? 1,
      pageSize: payload.pageSize ?? 25,
    });

    return await apiCall<
      BackResponse<StockItemGroupInInventoryWithStatsSummariesDto>
    >(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
